/**
 *
 * @fileoverview ApiService
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
 */

import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NavController, ToastController} from '@ionic/angular';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  public url: string = 'https://dev.siconfianza.com/api/';

  public headers: any;

  constructor(
    private http: HttpClient,
    private nav: NavController,
    private toast: ToastController,
    private auth: AuthService
  ) {
    //this.url = 'http://127.0.0.1:8000/api/';
    this.url = 'https://dev.siconfianza.com/api/';
    this.setHeaders();
  }

  setHeaders() {
    this.headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
    });
  }

  post(path, data, headers: any = this.headers) {
    this.setHeaders();
    var simbol = path.includes('?') ? '&' : '?';
    return new Promise((resolve, reject) => {
      this.http.post(`${this.url}${path}${simbol}`, data, {headers: headers})
        .subscribe(data => {
          resolve(data);
        }, error => {
          if (error.status == 401) {
            this.presentToast('Parece que no puedes acceder a este contenido');
          }
          reject(error);
        });
    });
  }

  get(path, headers: any = this.headers) {
    this.setHeaders();
    var simbol = path.includes('?') ? '&' : '?';
    return new Promise((resolve, reject) => {
      this.http.get(`${this.url}${path}${simbol}`, {headers: headers})
        .subscribe(data => {
          resolve(data);
        }, error => {
          if (error.status == 401) {
            this.presentToast('Parece que no puedes acceder a este contenido');
          }
          reject(error);
        });
    });
  }

  put(path, data, headers: any = this.headers) {
    this.setHeaders();
    var simbol = path.includes('?') ? '&' : '?';
    return new Promise((resolve, reject) => {
      this.http.put(`${this.url}${path}${simbol}`, data, {headers: headers})
        .subscribe(data => {
          resolve(data);
        }, error => {
          if (error.status == 401) {
            this.presentToast("Parece que no puedes acceder a este contenido");
          }
          reject(error);
        });
    });
  }

  delete(path, headers: any = this.headers) {
    this.setHeaders();
    var simbol = path.includes('?') ? '&' : '?';
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.url}${path}${simbol}`, {headers: headers})
        .subscribe(data => {
          resolve(data);
        }, error => {
          if (error.status == 401) {
            this.presentToast("Parece que no puedes acceder a este contenido");
          }
          reject(error);
        });
    });
  }

  async presentToast(txt) {
    const toast = await this.toast.create({
      message: txt,
      duration: 3000,
      position: 'bottom',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

}
